import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconBuilding = ({ t, className, height, width, fill }) => (
  <svg className={className} width={width} height={height} viewBox='0 0 23 23'>
    <title>{t('House')}</title>
    <g fill='none' fillRule='evenodd'>
      <path
        fill={fill}
        d='M22.073 7.968L12.215.238a1.164 1.164 0 00-1.408 0L.977 7.91A2.355 2.355 0 000 9.808V21.85C0 22.483.517 23 1.15 23h20.693c.633 0 1.15-.517 1.15-1.15V9.808c0-.747-.374-1.466-.92-1.84zm-1.38 12.733H10.348v-8.623a.577.577 0 00-.575-.574H5.173a.577.577 0 00-.574.574v8.623h-2.3V9.779l9.197-7.156 9.197 7.185V20.7z'
      />
      <path
        fill={fill}
        d='M18.394 12.078a.577.577 0 00-.575-.574h-4.598a.577.577 0 00-.575.574v2.3c0 .316.259.575.575.575h4.598a.577.577 0 00.575-.575v-2.3z'
      />
    </g>
  </svg>
)

export default Icon(IconBuilding)
